import { apiClient } from './client';
import type { Vermieter, Listing, VerfahrenListItem, Anfrage } from '../types';
import type { PaginatedResponse } from '../types/api';

export type VermieterListResponse = PaginatedResponse<Vermieter>;

export interface VermieterCreateData {
  anrede?: string;
  name: string;
  typ?: string;
  email?: string;
  telefon?: string;
  strasse?: string;
  hausnummer?: string;
  plz?: string;
  ort?: string;
  land?: string;
  geburtsdatum?: string | null;
  notes?: string;
}

export const vermieterApi = {
  getVermieter: async (params: { page?: number; per_page?: number; search_text?: string; sort_by?: string; sort_dir?: 'asc' | 'desc'; include_hidden?: boolean } = {}): Promise<VermieterListResponse> => {
    const { data } = await apiClient.get('/vermieter/', { params });
    return data;
  },

  getVermieterDetail: async (id: number): Promise<Vermieter> => {
    const { data } = await apiClient.get(`/vermieter/${id}`);
    return data;
  },

  createVermieter: async (body: VermieterCreateData): Promise<Vermieter> => {
    const { data } = await apiClient.post('/vermieter/', body);
    return data;
  },

  updateVermieter: async (id: number, updates: Partial<VermieterCreateData>): Promise<Vermieter> => {
    const { data } = await apiClient.patch(`/vermieter/${id}`, updates);
    return data;
  },

  getInserate: async (id: number): Promise<Listing[]> => {
    const { data } = await apiClient.get(`/vermieter/${id}/inserate`);
    return data;
  },

  getVerfahren: async (id: number): Promise<VerfahrenListItem[]> => {
    const { data } = await apiClient.get(`/vermieter/${id}/verfahren`);
    return data;
  },

  getAnfragen: async (id: number): Promise<Anfrage[]> => {
    const { data } = await apiClient.get(`/vermieter/${id}/anfragen`);
    return data;
  },

  deleteVermieter: async (id: number): Promise<void> => {
    await apiClient.delete(`/vermieter/${id}`);
  },
};
